import React from "react";
import { AppList } from "components/list/AppList";
import { Datagrid, EditButton, TextField } from "react-admin";

import { DatagridWithBlockDeleteProps } from "../../../components/_helpers/props/DatagridProps";
import { stylesForColorInheritInList } from "../../../components/_helpers/useStyles";
import { CopyField } from "../../../components/fields/CopyField";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { TerminalsActions } from "./Actions";
import { TerminalsFilter } from "./ListFilters";

const defaultSort = { field: "id", order: "DESC" };

export const TerminalsList = (props) => {
	const classes = stylesForColorInheritInList();

	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<TerminalsFilter />}
			actions={<TerminalsActions />}
			classes={classes}
		>
			<ScrollingWrapper>
				<Datagrid {...DatagridWithBlockDeleteProps} rowClick="edit">
					<TextField source="id" />
					<TextField source="name" />
					<TextField source="short_name" />
					<TextField source="account_code" />
					<TextField source="time_zone" />
					<TextField source="address" />
					<CopyField
						source="guid"
						variant="button"
						style={{
							width: "250px",
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							display: "inline-block",
						}}
					/>
					<EditButton />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
